import ACTION_TYPE from 'components/../redux/actions/actionTypes';

const initialState = {
    organization: {
        isLoading: false,
        data: [],
        selected: null
    },
    viewsList: [],
    groups: [],
    deviceTypes: [],
    policies: [],
    licenses: [],
    labels: []
};

const managementReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPE.LOADING_MANAGEMENT_DTL:
            return {
                ...state,
                [action.fieldName]: {
                    ...state[action.fieldName],
                    isLoading: action.data
                }
            };
        case ACTION_TYPE.UPDATE_MANAGEMENT_DTL:
            return {
                ...state,
                [action.fieldName]: {
                    ...state[action.fieldName],
                    ...action.data,
                    isLoading: false
                }
            };
        case ACTION_TYPE.AUTH_LOGOUT:
            return initialState;
        case ACTION_TYPE.SET_VIEWS_LIST:
            return {
                ...state,
                [action.fieldName]: action.data
            };
        case ACTION_TYPE.SET_GROUPS:
            return {
                ...state,
                [action.fieldName]: action.data
            };
        case ACTION_TYPE.SET_DEVICE_TYPES:
            return {
                ...state,
                [action.fieldName]: action.data
            };
        case ACTION_TYPE.SET_POLICIES:
            return {
                ...state,
                [action.fieldName]: action.data
            };
        case ACTION_TYPE.SET_LICENSES:
            return {
                ...state,
                [action.fieldName]: action.data
            };
        case ACTION_TYPE.SET_LABELS:
            return {
                ...state,
                [action.fieldName]: action.data
            };

        default:
            return state;
    }
};

export default managementReducer;
